import type { AnyCodeDictionary } from '@mypoz/i18n';

/**
 * `claimpkgtype` — how the customer's packages are pulled into an order: by hand, or
 * automatically. Two states only, mirroring the wallet's own MANUAL/AUTO payment mode; confirm
 * against the real endpoint once MYP-73 can call it.
 */
export const CLAIM_TYPE = [
  { code: 'AUTO', labelKey: 'dict.claimType.auto' },
  { code: 'MANUAL', labelKey: 'dict.claimType.manual' },
] as const satisfies AnyCodeDictionary;
